<template>
    <ValidationObserver tag="form" ref="paso2" @submit.prevent="submit()">
        <b-row>
            <b-col cols="12" class="d-md-flex justify-content-between align-items-center mb-3 mb-md-0">
                <TitleComponent title="2. Tus abonos" subtitle="- Completa la información necesaria para cada uno de los abonos seleccionados" />
                <Button :disabled="disabled" @click="cambiarButacas">Cambiar abonos</Button>
            </b-col>
            <b-col cols="12 mb-4">
                <div class="custom-control custom-checkbox">
                    <input class="custom-control-input" type="checkbox" v-model="select_all" id="select_all" :disabled="disabled"/>
                    <label class="custom-control-label pt-1" for="select_all">Seleccionar todos los abonos</label>
                </div>
            </b-col>
            <b-col cols="12">
                <b-row id="datos-abonos">
                    <template v-for="(abono, index) in datos_de_compradores">
                        <b-col lg="4" md="6" sm="12" :key="index">
                            <DatosAbonoComponent
                                :index="index"
                                :abono="abono"
                                :generos="generos"
                                :precios="precios"
                                :area="abono.area"
                                :desactivar="disabled"
                                :validator="$refs.observer"
                                @borrar="borrar(index)"
                                @actualizado="actualizar(index)"
                                @isValidNumber="validarTelefono"
                            />
                        </b-col>
                    </template>
                </b-row>
            </b-col>
            <template v-if="tienenPrecio">
                <b-col cols="12">
                    <Button id="continuar-paso3" type="submit" class="btn-block" :disabled="disabled">
                        CONTINUAR COMPRA
                    </Button>
                </b-col>
            </template>
        </b-row>
    </ValidationObserver>
</template>

<script>
    import TitleComponent from '@/components/backend/stepper/components/TitleComponent';
    import DatosAbonoComponent from '@/components/backend/stepper/components/DatosAbonoComponent';

    export default {
        props: {
            datos_compradores: {
                type: Array,
                required: true
            },
            precios: {
                type: Array,
                required: true
            },
            disabled: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                select_all: false,
                isValidNumber: []
            }
        },
        methods: {
            async submit() {
                const isValid = await this.$refs.paso2.validate();
                const allPhonesValid = this.isValidNumber.every(valid => valid);

                if(isValid && allPhonesValid) {
                    this.$emit('terminado', this.datos_de_compradores);
                } else {
                    this.$nextTick(function() {
                        this.$scrollTo('.is-invalid');
                    });
                }
            },
            actualizar(index) {
                if (this.select_all && parseInt(index) === 0) {
                    this._broadcastFromFirst();
                }

                this.$emit('actualizar', this.datos_compradores);
            },
            _broadcastFromFirst() {
                if (!this.select_all) return;

                const first = this.datos_compradores[0];
                if (!first) return;

                for (let i = 1; i < this.datos_compradores.length; i++) {
                    const datos = Object.assign({}, first);

                    if (this.datos_compradores[i].id !== undefined) {
                        datos.id = this.datos_compradores[i].id;
                    }

                    if (this.datos_compradores[i].area !== undefined) {
                        datos.area = this.datos_compradores[i].area;
                    }

                    this.$set(this.datos_compradores, i, datos);
                }
            },
            borrar(index) {
                this.$emit('borrado', index);
            },
            cambiarButacas() {
                this.$emit('cambiarButacas', 1, true)
            },
            validarTelefono({ index, valid }) {
                this.$set(this.isValidNumber, index, valid);
            }
        },
        watch: {
            select_all(newVal) {
                if (newVal) {
                    this._broadcastFromFirst();
                }
            }
        },
        computed: {
            tienenPrecio() {
                let precio = true;

                Object.values(this.datos_de_compradores).forEach(abono => {
                    if(abono.precio == undefined) {
                        precio = false;
                    }
                })

                return precio;
            },
            datos_de_compradores() {
                return this.datos_compradores;
            },
            generos() {
                return this.$store.getters.getGeneros;
            }
        },
        components: {
            TitleComponent, DatosAbonoComponent
        }
    }
</script>